import { useState, useEffect, useRef } from 'react';

const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

export const useAnimatedValue = (targetValue = 0, animationDuration = 1250) => {
  const [displayValue, setDisplayValue] = useState(0);
  const prevTargetValueRef = useRef<number>(0);
  const requestRef = useRef<number | null>(null);

  useEffect(() => {
    const start = Date.now();

    const animate = () => {
      const elapsedTime = Date.now() - start;
      const progress = easeOutCubic(
        Math.min(elapsedTime / animationDuration, 1),
      );
      const currentValue = Math.floor(progress * targetValue);

      setDisplayValue(currentValue);

      if (progress < 1) {
        requestRef.current = requestAnimationFrame(animate);
      }
    };

    if (prevTargetValueRef.current === 0) {
      requestRef.current = requestAnimationFrame(animate);
    }

    if (prevTargetValueRef.current !== 0) {
      setDisplayValue(targetValue);
    }

    prevTargetValueRef.current = targetValue;

    return () => {
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current);
      }
    };
  }, [animationDuration, targetValue]);

  return displayValue;
};
